module.exports = __webpack_public_path__ + "static/media/drawer-button-close.e5ce19c5.svg";